import React, { useContext } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AssistiveTechnologyOnly } from '../../../styles/AssistiveTechnologyOnly';
import { MainNavigationContext } from '../MainNavigationContext';
import { useIsMobileNavigation } from '../hooks/useIsMobileNavigation';
const DesktopList = styled.ul `
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  font-size: ${props => props.fontSizeDesktopInRem || '1.25'}rem;
  height: 100%;
  list-style-type: none;
`;
const DesktopListItem = styled.li `
  margin-left: ${props => props.distanceBetweenItemsInRem}rem;

  &:first-of-type {
    margin-left: 0;
  }
`;
const MobileList = styled.ul `
  text-align: center;
  display: grid;
  grid-gap: 2rem;

  @supports (grid-gap: clamp(1.5rem, 5vh, 2.5rem)) {
    grid-gap: clamp(1.5rem, 5vh, 2.5rem);
  }
`;
const MobileListItem = styled.li `
  font-size: 1.125rem;
  line-height: 1.33;
`;
const FullHeightNav = styled.nav `
  ${props => !props.isMobile && 'height: 100%'};
  width: 100%;
`;
const VisuallyHiddenLabel = styled.h2 `
  ${AssistiveTechnologyOnly}
`;
function renderListItems(children, isMobile, distanceBetweenItemsInRem = 0) {
    return React.Children.map(children, (child, index) => {
        if (child !== null) {
            return isMobile ? (React.createElement(MobileListItem, { key: index }, child)) : (React.createElement(DesktopListItem, { distanceBetweenItemsInRem: distanceBetweenItemsInRem, key: index }, child));
        }
        else {
            return null;
        }
    });
}
const ID_PRIMARY_NAVIGATION_LABEL = 'primary-navigation-label';
export const PrimaryNavigation = ({ children = null, fontSizeDesktopInRem = 0, }) => {
    const { t } = useTranslation('MainNavigation');
    const isMobile = useIsMobileNavigation();
    const { distanceBetweenPrimaryNavigationItemsInRem } = useContext(MainNavigationContext);
    return (React.createElement(FullHeightNav, { "aria-labelledby": ID_PRIMARY_NAVIGATION_LABEL, isMobile: isMobile },
        React.createElement(VisuallyHiddenLabel, { id: ID_PRIMARY_NAVIGATION_LABEL }, t('PrimaryNavigationLabel')),
        isMobile ? (React.createElement(MobileList, null, renderListItems(children, isMobile))) : (React.createElement(DesktopList, { fontSizeDesktopInRem: fontSizeDesktopInRem }, renderListItems(children, isMobile, distanceBetweenPrimaryNavigationItemsInRem)))));
};
